import { SchedulerRouterHelper } from '../helpers/router_helper';
import { SchedulerActiveTermQuery } from '../../scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query';
import { ILogService } from '../../interfaces/scheduler_interfaces';
import { AccountModel } from 'data-ng-authentication';
import { TStandaloneNavigationModel } from '../models/standalone_navigation_model';
import { FetchSchedulerAvailableTermsCommand } from '../../scheduler_active_term/commands/fetch_scheduler_available_terms_command';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type TNavigateToSchedulerCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'navigateToSchedulerCommand',
    (
      fetchSchedulerAvailableTermsCommand: FetchSchedulerAvailableTermsCommand,
      ngStandaloneNavigationModel: TStandaloneNavigationModel,
      ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
      ngSchedulerRouterHelper: SchedulerRouterHelper,
      log: ILogService,
      accountModel: AccountModel,
      defineCommandORM: IDefineCommand
    ) =>
      defineCommandORM('navigateToSchedulerCommand', (deferred) => {
        const currentUserID = accountModel.id;
        if (!_4.isNumber(currentUserID)) {
          log.error('unable to load scheduler');
          return deferred.reject('User id not available');
        }

        const schedulerState = 'my.schedule.registration';
        const standaloneNavModel = ngStandaloneNavigationModel.read();
        const lastAccessedUserId = standaloneNavModel.userId;
        if (lastAccessedUserId === currentUserID) {
          return ngSchedulerRouterHelper.navigateFromRouter(
            deferred,
            schedulerState,
            {
              termId: ngSchedulerActiveTermQuery.result.id
            },
            {
              location: 'replace'
            }
          );
        }

        ngStandaloneNavigationModel.write({
          userId: accountModel.id,
          apiCurrentTerm: standaloneNavModel.apiCurrentTerm
        });
        return fetchSchedulerAvailableTermsCommand().then(() =>
          ngSchedulerRouterHelper.navigateFromRouter(
            deferred,
            schedulerState,
            {
              termId: ngStandaloneNavigationModel.read().apiCurrentTerm
            },
            {
              location: 'replace'
            }
          )
        );
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/standalone_scheduler/commands/navigate_to_scheduler_command.ts